export function notEmpty(value) {
    return value !== null && value !== undefined;
}
export function tenify(num) {
    return Math.abs(num) > 9 ? num : `0${num}`;
}
export function arrayRemove(arr, item) {
    const idx = arr.indexOf(item);
    return arr.splice(idx, 1);
}
export function createDefer() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return [promise, resolve, reject];
}
export const EMPTY_LIST = Object.freeze([]);
export const wait = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};
export function unreachable(value) {
    console.error('Unhandled value: ', value);
    throw new Error('Unreachable case:' + value);
}
export function switchAddressToBase64(address) {
    const hex = address
        ?.replace(/^0x/, '')
        ?.match(/.{1,2}/g)
        ?.map((byte) => Number.parseInt(byte, 16));
    const uint8Array = new Uint8Array(hex ?? []);
    return Buffer.from(uint8Array).toString('base64');
}
